import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Form } from 'components/atoms/form';
import { Select } from 'components/atoms/select';
import { useTranslation } from 'hooks/use-translation';
import { usePublishedProjectTemplateOptionsQuery } from 'queries/templates/project-templates';
import { Props } from './types';

export const SourceFormItem: FC<Props> = ({ field }) => {
  const requiredMessage = useTranslation('input.required');
  const { data: options, isLoading } =
    usePublishedProjectTemplateOptionsQuery();

  return (
    <Form.Item
      id="template-form-item"
      data-cy="project-template-form-item"
      {...field}
      name={[field.name, 'source']}
      fieldKey={[field.fieldKey, 'source']}
      rules={[
        {
          required: true,
          message: requiredMessage,
        },
      ]}
      label={<FormattedMessage id="projects.phase.import.template" />}
    >
      <Select
        options={options}
        isClearable
        isLoading={isLoading}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 'var(--zindex-popover-low)',
          }),
        }}
      />
    </Form.Item>
  );
};
